export const KNOWLEDGE_BASE_URL = {
  AD_HOLDING: 'https://knowledge-base.yieldbird.com/viewability-tools/ad-holding',
  LAZY_LOADING: 'https://knowledge-base.yieldbird.com/viewability-tools/lazy-loading',
  SCROLL_SLOWING: 'https://knowledge-base.yieldbird.com/viewability-tools/scroll-slowing',
} as const
